import { jsx as _jsx } from "react/jsx-runtime";
import { useScrollStore } from "@faire/web--source/common/ScrollStore";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useEffect } from "react";
import { usePromoBanners } from "@faire/retailer/stores/ui/usePromoBanners";
import { HeaderSearch } from "../HeaderSearch";
import { MenuContainer } from "./styled";
export var HeaderMobileSearch = function(props) {
    var viewport = useViewport();
    var visibleHeight = usePromoBanners().visibleHeight;
    var _useScrollStore = useScrollStore([
        "pushNoScroll",
        "popNoScroll"
    ]), pushNoScroll = _useScrollStore.pushNoScroll, popNoScroll = _useScrollStore.popNoScroll;
    useEffect(function() {
        pushNoScroll();
        return function() {
            popNoScroll();
        };
    }, [
        popNoScroll,
        pushNoScroll
    ]);
    return /*#__PURE__*/ _jsx(MenuContainer, {
        style: {
            top: 0,
            height: "100%"
        },
        $height: visibleHeight,
        children: viewport.isMobile ? /*#__PURE__*/ _jsx(HeaderSearch, {
            inputId: props.inputId,
            inputDataTestId: props.inputDataTestId
        }) : null
    });
};
